define.alias("shared/components/shared/color-picker/header", "preview-grid/components/shared/color-picker/header");